var _defs, _line, _line2, _polyline, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#020202;stroke-miterlimit:10;stroke-width:2px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4,
    y1: 15.5,
    x2: 4,
    y2: 8.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20,
    y1: 8.5,
    x2: 20,
    y2: 15.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "23 10.5 12 1.5 1 10.5"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7,
    y1: 14.5,
    x2: 9,
    y2: 14.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11,
    y1: 14.5,
    x2: 13,
    y2: 14.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15,
    y1: 14.5,
    x2: 17,
    y2: 14.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7,
    y1: 22.5,
    x2: 9,
    y2: 22.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3,
    y1: 22.5,
    x2: 5,
    y2: 22.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11,
    y1: 22.5,
    x2: 13,
    y2: 22.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15,
    y1: 22.5,
    x2: 17,
    y2: 22.5
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19,
    y1: 22.5,
    x2: 21,
    y2: 22.5
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3,
    y1: 18.5,
    x2: 5,
    y2: 18.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19,
    y1: 18.5,
    x2: 21,
    y2: 18.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilder);
export default __webpack_public_path__ + "static/media/builder.d361652482f5e5794e14d4c9a78935c1.svg";
export { ForwardRef as ReactComponent };